module.exports = __webpack_public_path__ + "static/media/prolift.42a823e3.png";